import { type FitViewOptions } from '@xyflow/react';
import { reactFlowInstance } from 'automations/components/ReactFlowUtil';

export function fitView({
  duration = 300,
  padding = 2,
  nodes = [],
  ...rest
}: FitViewOptions) {
  const instance = reactFlowInstance;
  if (instance?.fitView) {
    setTimeout(() => {
      instance.fitView({
        duration,
        padding,
        nodes,
        ...rest,
      });
    }, 0);
  }
}
